<template>
  <div class="pack-toggler" @click="onTogglerClick">
    <!-- Text -->
    <div
      class="pack-toggler__text"
      :class="toggled ? 'pack-toggler__text--toggled' : ''"
    >{{ toggled ? '' : 'CAMBIA A ' }}DESTACADO</div>

    <!-- Star -->
    <svg
      class="pack-toggler__star"
      :class="toggled ? 'pack-toggler__star--toggled' : ''"
      version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 511 511" style="enable-background:new 0 0 511 511;" xml:space="preserve">
    <path class="st0" d="M509.7,196c-3.4-10.3-12.5-17.7-23.4-18.7L338.8,164L280.5,27.5c-4.3-10-14.1-16.5-25-16.5
      c-10.9,0-20.7,6.5-25,16.5L172.2,164L24.7,177.3c-10.8,1-20,8.3-23.4,18.7c-3.4,10.3-0.3,21.7,7.9,28.9l111.5,97.8L87.9,467.4
      c-2.4,10.6,1.7,21.7,10.6,28c4.7,3.5,10.3,5.2,15.9,5.2c4.8,0,9.6-1.3,13.9-3.9l127.2-76.1l127.2,76.1c9.3,5.6,21.1,5.1,29.9-1.3
      c8.8-6.4,13-17.4,10.6-28l-32.9-144.8l111.5-97.8C509.9,217.7,513,206.4,509.7,196z"/>
    </svg>

    <!-- Pennon -->
    <svg
      class="pack-toggler__pennon"
      :class="toggled ? 'pack-toggler__pennon--toggled' : ''"
      version="1.1" xmlns:x="&ns_extend;" xmlns:i="&ns_ai;" xmlns:graph="&ns_graphs;"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px" y="0px"
      viewBox="21 15 58 66" style="enable-background:new 21 15 58 66;" xml:space="preserve"
    >
      <path d="M80,81.58l-29.58-9.8L20,81.58V14h60V81.58z"/>
    </svg>
  </div>
</template>

<script>
export default {
    name: "PackToggler",

    props: {
        toggled: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        onTogglerClick() {
            this.$emit("toggler-click");
        }
    }
};
</script>
